import React, { Component } from "react";
import { connect } from "react-redux";
import { changeView } from "../../actions/assessment";
import { SaveUserStateToServerHelper } from "../Helper";
import imgBulb from "./../../assets/img/icon-bulb.svg";

import { Translate } from "react-redux-i18n";
import Button from "../ui/Buttons/Button";

export class PracticeInstruction extends Component {
  componentDidMount() {
    SaveUserStateToServerHelper(this.props.assessment);
  }

  skip_practice = () => {
    let exams = this.props.assessment.exams;
    let exam_name = exams[this.props.assessment.exam_index].name;
    if (
      [
        "Typing Test V1",
        "Typing Test V2",
        "Data Entry V1",
        "Data Entry V2",
      ].includes(exam_name)
    ) {
      exams[this.props.assessment.exam_index].is_practice_done = true;
      this.props.assessment.is_typing_started = false;
      this.props.assessment.start_time = 0;
      this.props.show_practice_instruction();
    }
  };

  proceed_practice_test = () => {
    this.props.assessment.status = 0;
    this.props.start_practice_test();
  };

  render() {
    const i18n = require("react-redux-i18n").I18n;
    let instruct_sub_lead = null;
    let practice_instruction = null;

    if (["Typing Test V1", "Typing Test V2"].includes(this.props.exam_name)) {
      instruct_sub_lead = (
        <Translate value="instruct_sub_lead_practice_test_typing" />
      );
      practice_instruction = (
        <>
          <p>
            The following Screen includes a practice (warm up) typing test.
            Please use this test to “warm up” for the scored test section. Your
            keystrokes will not be captured during this practice test. Please
            follow the following instructions when completing this test.
          </p>
          <ul>
            <li>
              Look at the text in the box on the left and type this text exactly
              as it appears in the box on the right. This includes punctuation
              and capitalization.
            </li>
            <li>
              Try your best to type the text as fast and accurate as you can as
              you will be evaluated on both speed and accuracy.
            </li>
            <li>
              Enter only one space after each sentence. Using 2 spaces will be
              counted as one incorrect entry.
            </li>
            <li>
              Do not hit the Enter key when you reach the end of a line. The
              text will automatically wrap to the next line by itself.
            </li>
            <li>To start a new paragraph, you must hit the Enter Key twice.</li>
            <li>
              If you make mistakes, you can correct them using the Backspace,
              Delete, and arrow keys.
            </li>
          </ul>
          <p>
            Once you click the "START PRACTICE TEST" button, the practice test
            screen will appear. The timer in the upper right-hand corner will
            begin once you type the first character. You have 2 minutes for this
            practice test. The practice test will end on its own after 2
            minutes. You can also end the practice test by clicking on the “END
            PRACTICE TEST” button.
          </p>
          <p>
            If you wish to skip the practice test, just click on the “SKIP
            PRACTICE TEST” button below.
          </p>
        </>
      );
    } else {
      instruct_sub_lead = (
        <Translate value="instruct_sub_lead_practice_test_data_entry" />
      );
      practice_instruction = (
        <>
          <p>
            The following screen includes a practice (warm up) data entry test.
            Please use this test to “warm up” for the scored test section. Your
            keystrokes will not be captured during this practice test. Please
            adhere to the following instructions when completing this test.
          </p>
          <ul>
            <li>
              Look at the completed form on the left half of the screen and type
              the same information into the corresponding empty fields on the
              right. Try your best to type the information as fast and accurate
              as you can. You will be evaluated on both speed and accuracy.
            </li>
            <li>
              Type the data exactly as it appears in the completed form. This
              includes punctuation and capitalization.
            </li>
            <li>You are required to start typing on the first field.</li>
            <li>
              Use either the Tab or Enter key at the end of each data string to
              move to the next data field.
            </li>
            <li>
              To move to a previous field, you can hold the Shift key and press
              the Tab key. You can also use your mouse or trackpad.
            </li>
            <li>
              If you make mistakes, you can correct them using the Backspace,
              Delete, and arrow keys.
            </li>
            <li>
              You will be presented with numerous forms until your time runs
              out.
            </li>
            <li>
              When you complete typing the last string of a form, press the
              Enter key to move to the next form.
            </li>
            <li>
              Once you press the Enter key at the end of the last string of a
              form, this moves you to the next form. Once this occurs, you will
              not be able to go back to the previous form. Therefore, please
              make any desired edits to data entered on a form before pressing
              the Enter key at the end of the last string.
            </li>
          </ul>
          <p>
            Once you click the "START PRACTICE TEST" button, the practice test
            screen will appear. The timer in the upper right-hand corner will
            begin once you type the first character. You have 2 minutes for this
            practice test. The practice test will end on its own after 2
            minutes. You can also end the practice test by clicking on the “END
            PRACTICE TEST” button.{" "}
          </p>
          <p>
            If you wish to skip the practice test, just click on the “SKIP
            PRACTICE TEST” button below.
          </p>
        </>
      );
    }

    return (
      <div className="main container-fluid h-100">
        <div className="row test-container align-items-md-center">
          <div className="col-12">
            <div className="container">
              <div className="test-instruction ">
                <div className="row  justify-content-center ">
                  <div className="col-md- ">
                    <h3 className="mt-5 mb-4">
                      <Translate value="instruct" />
                    </h3>
                    <div className="reminder">
                      <img
                        src={imgBulb}
                        className="d-table-cell"
                        width="30px"
                        height="30px"
                        alt={i18n.t("instruct")}
                      />
                      <div>
                        <p className="lead mb-2">
                          <Translate value="instruct_lead" />
                        </p>
                        <p>{instruct_sub_lead}</p>
                      </div>
                    </div>
                    {practice_instruction}

                    <div className="mt-4">
                      <div className="button-wrap mt-md-5">
                        {/* <button
                          onClick={this.proceed_practice_test}
                          className="btn btn-main btn-global ord-1 w-auto"
                        >
                          Start Practice Test
                        </button> */}
                        {/* <button
                          onClick={this.skip_practice}
                          className="btn btn-outline-white btn-global ord-2 w-auto"
                        >
                          Skip Practice Test
                        </button> */}
                        {/* <button
                          onClick={this.props.exit_session}
                          className="btn btn-outline-white btn-global ord-3"
                        >
                          <Translate value="exit_session" />
                        </button> */}

                        <Button
                          variant="primary"
                          className="btn-global ord-1 w-auto"
                          onClick={this.proceed_practice_test}
                        >
                          Start Practice Test
                        </Button>
                        <Button
                          variant="outline-white"
                          className="btn-global ord-2 w-auto"
                          onClick={this.skip_practice}
                        >
                          Skip Practice Test
                        </Button>
                        <Button
                          variant="outline-white"
                          className="btn-global ord-3"
                          onClick={this.props.exit_session}
                        >
                          <Translate value="exit_session" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
  exams: state.assessment.exams,
  exam_index: state.assessment.exam_index,
  exam_name: state.assessment.exams[state.assessment.exam_index].name,
});

const mapDispatchToProps = (dispatch) => ({
  exit_session: () => dispatch(changeView("session_details")),
  start_practice_test: () => dispatch(changeView("practice_test")),
  show_practice_instruction: () => dispatch(changeView("instruction")),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PracticeInstruction);
